export default __webpack_public_path__ + "static/media/QK_9412.0d31df3b.jpg";